// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { footerContainerStyles } from "@eisinc/Overrides/Widgets/Footer/FooterContainer";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color, layoutContainer, xScreen } from "@eisinc/XDL/Utilities";
import { ContentWrapper } from "@insite/content-library/Widgets/Basic/RichContent";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

footerContainerStyles.container = {
    css: css`
        background: ${color("common.ui2")};
    `,
};

const topNavLinkStyles = css`
    & nav[class^="ListNav"] {
        padding: 0;
        .link-list-heading {
            margin-bottom: 8px;

            ${TypographyStyle} {
                font-size: ${fontConfig.singleLineRegular.size}px;
                line-height: ${fontConfig.singleLineRegular.lineHeight};
                font-weight: ${fontConfig.weight.medium};
                text-transform: capitalize;
                margin-bottom: 0;
            }
        }
        .link-list-items {
            display: flex;
            gap: 14px;
            flex-direction: column;
            max-height: unset;

            li:empty {
                display: none;
            }
            li {
                padding: 0;
                display: flex;
                .item-link {
                    ${TypographyStyle} {
                        color: ${color("text.main")};
                        font-size: ${fontConfig.singleLineSmall.size}px;
                        line-height: ${fontConfig.singleLineSmall.lineHeight};
                        font-weight: ${fontConfig.weight.regular};
                        text-transform: capitalize;
                        margin-bottom: 0;
                    }
                    &:hover ${TypographyStyle} {
                        color: ${color("text.link")};
                    }
                }
            }
        }
    }
`;

footerContainerStyles.topInnerContainer = {
    css: css`
        display: grid;
        grid-template-columns: repeat(4, minmax(180px, 204px)) 1fr;
        gap: 24px 22px;
        padding: 24px 0;

        ${xScreen("lt", "lg")} {
            grid-template-columns: repeat(4, 1fr);
        }

        ${xScreen("lte", "sm")} {
            grid-template-columns: repeat(2, 1fr);
        }

        ${layoutContainer}
        ${topNavLinkStyles}
    `,
};

footerContainerStyles.subscribeContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 33px;

        ${xScreen("lt", "lg")} {
            grid-column: 1/5;
        }
        ${xScreen("lte", "sm")} {
            grid-column: 1/3;
        }

        ${ContentWrapper} > ${TypographyStyle} {
            font-size: ${fontConfig.singleLineRegular.size}px;
            line-height: ${fontConfig.singleLineRegular.lineHeight};
            font-weight: ${fontConfig.weight.medium};
            margin-bottom: 8px;
        }
    `,
};
